import { v4 as uuidv4 } from 'uuid';
import {
  ChapterPayload,
  DocumentEditorActionsType,
  DocumentEditorNotification, DocumentEditorNotificationScope, DocumentEditorNotificationType,
  MAIL_REGEX,
  TemplatePayload,
  UiWidget
} from '@pt/pt-models';
import { Observable } from 'rxjs';
import { GetChapterResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';
import { ChapterSelector } from 'it/primatoo/openapi/api/org/schemas/common/docs/ChapterSelector';
import { Widget } from 'it/primatoo/openapi/api/org/schemas/common/docs/Widget';

export class WidgetUtils {
  private static id = 0;

  static isValidMail(mail: string, optional = false) {
    let isValid = true;
    switch (true) {
      case optional && !mail:
      case optional && mail.length === 0:
        isValid = true;
        break;
      case !optional && !mail:
      case !optional && mail === '':
      case !optional && !mail.match(MAIL_REGEX):
        isValid = false;
        break;
    }
    return isValid;
  }

  static isInvalidMail(mail: string, optional = false) {
    let isValid = true;
    switch (true) {
      case optional && !mail:
      case optional && mail.length === 0:
        isValid = true;
        break;
      case !optional && (!mail || mail === '' || !mail.match(MAIL_REGEX)):
        isValid = false;
        break;
    }
    return !isValid;
    // return !mail || mail === '' || !mail.match(MAIL_REGEX);
  }

  static generateUUID() {
    return uuidv4();
  }

  static generateId(prefix?: string): string {
    this.id = this.id + 1;
    return prefix ? prefix + this.id : this.id + '';
  }

  static mappingQueryResponse(queryResponse: unknown[], mapping: unknown): unknown[] {
    const response: unknown[] = [];
    if (mapping) {
      const keys = Object.keys(mapping);
      if (queryResponse) {
        queryResponse.forEach((q: unknown) => {
          const obj = {};
          keys.forEach((outputKey: string) => {
            obj[outputKey] = q[mapping[outputKey]];
          });
          response.push(obj);
        });

      }
    }
    return response;
  }

  /**
   * @deprecated The method should not be used
   */
  static getWidgetNotSaved(payload: TemplatePayload): UiWidget[] {
    const widgets: UiWidget[] = [];
    payload?.groups?.forEach(group => {
      if (group.enabled) {
        group?.widgets?.forEach(widget => {
          if (!widget.saved) {
            widgets.push(widget);
          }
        });
      }
    });
    return widgets;
  }

  static getWidgetNotSavedFromChapterPayload(payload: ChapterPayload): UiWidget[] {
    const widgets: UiWidget[] = [];
    for (const group of payload.groups) {
      if (group.enabled) {
        for (const widget of group.widgets) {
          if (widget.saved === false) {
            widgets.push(widget);
          }
        }
      }
    }
    return widgets;
  }

  static getWidgetsFromChapter(response: GetChapterResponse) {
    const widgets: UiWidget[] = [];
    response?.payload?.groups?.forEach(group => {
      if (group.enabled) {
        // const widgetEnabled = group?.widgets?.filter(w => w.enabled);
        // if (widgetEnabled) {
        //   widgets.push(...widgetEnabled);
        // }
        widgets.push(...group.widgets);
      }
    });
    return widgets;
  }

  static generateWidgetNotification(widgetInternalId: number, name: string, action: DocumentEditorActionsType, message: Observable<string>, type: DocumentEditorNotificationType, scope: DocumentEditorNotificationScope): DocumentEditorNotification {
    return {
      id: WidgetUtils.generateId('g'),
      name,
      widgetInternalId,
      action,
      type,
      scope,
      message,
      timestamp: Date.now()
    } as DocumentEditorNotification;
  }

  static toWidgetRequest(widget: UiWidget, chapter: ChapterSelector): Widget {
    const response: Widget = {
      editable: widget.editable,
      internalId: widget.internalId,
      comment: widget.comment,
      chapter: chapter,
      opt: widget.opt,
      properties: widget.properties,
      type: widget.type,
      value: widget.value,
      version: widget.version,
      enabled: widget.enabled
    };
    return response;
  }
}
